export default __webpack_public_path__ + "static/media/ico-sq-15-land.0f5d8c45.svg";